import getFeedbackRibbonForSpotlightFeedbackInfoBar from './getFeedbackRibbonForSpotlightFeedbackInfoBar';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import { lazyGetSpotlightDonationJson, lazyGetSpotlightItem } from 'owa-mail-spotlight';
import Message from 'owa-service/lib/contract/Message';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import {
    InfoBarMessageRank,
    InfoBarMessageSource,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export default function createSpotlightFeedbackInfoBarViewState(
    message: Message,
    key: string,
    itemViewState: ItemViewState
): InfoBarMessageViewState {
    const getSpotlightItem = lazyGetSpotlightItem.tryImportForRender();
    const spotlightItem = getSpotlightItem?.({ itemId: message.ItemId.Id });

    // If item is not a Spotlight item, then we should not render the Spotlight feedback info bar.
    if (!spotlightItem) {
        return null;
    }

    // If lazy util isn't available, then we should not render the Spotlight feedback info bar.
    const getSpotlightDonationJson = lazyGetSpotlightDonationJson.tryImportForRender();
    if (!getSpotlightDonationJson) {
        return null;
    }

    const feedbackMetadata = JSON.stringify({
        internetMessageId: message.InternetMessageId,
        itemId: message.ItemId.Id,
        mbx: getUserConfiguration().SessionSettings.MailboxGuid,
    });

    return <InfoBarMessageViewState>{
        key: key,
        source: InfoBarMessageSource.ReadingPane,
        rank: InfoBarMessageRank.Info,
        messageElement: getFeedbackRibbonForSpotlightFeedbackInfoBar(
            itemViewState,
            key,
            getSpotlightDonationJson(spotlightItem.rowKey),
            feedbackMetadata
        ),
    };
}
